import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const linkStyle = {
    color: 'var(--muted)',
    textDecoration: 'none',
    fontFamily: 'Noto Sans, sans-serif',
  };

  return (
    <div style={{
      textAlign: 'center',
      fontSize: '0.78rem',
      color: 'var(--muted)',
      padding: '32px 20px calc(12px + env(safe-area-inset-bottom))',
      fontFamily: 'Noto Sans, sans-serif',
    }}>
      <Link to="/support" style={linkStyle}>{t('footer.support')}</Link>
      <span style={{ margin: '0 8px' }}>&middot;</span>
      <Link to="/privacy" style={linkStyle}>{t('footer.privacy')}</Link>
      <span style={{ margin: '0 8px' }}>&middot;</span>
      <Link to="/terms" style={linkStyle}>{t('footer.terms')}</Link>
    </div>
  );
}
